import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { imageUrl } from "../actions/miscAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AlertError from "./common/alertError";
import { useEffect } from "react";
import { getCategories, getMyReferrals, shareMyBuyerList } from "../actions/memberAction";
import LoadingBar from "react-top-loading-bar";
import Select from "react-select";
const trashIcon = imageUrl("trash.png");
const emptyIcon = imageUrl("Folder.svg");

const crosshair = imageUrl("crosshair.svg");

const regionOptions = [
  { name: "United States", value: "1" },
  { name: "Africa", value: "7" },
  { name: "Americas", value: "49" },
  { name: "Asia-Pacific", value: "50" },
  { name: "Europe", value: "4" },
  { name: "Middle East", value: "9" },
];

const ShareWithMyBuyers = (props) => {
  const ref = useRef(null);
  const [step, setStep] = useState("1");

  const [addedItem, setAddedItem] = useState([
    { name: "", email: "", phone: "", location: "", catgeory: [], company: "", region: "", type: "New" },
  ]);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [myReferrals, setMyReferrals] = useState([]);

  const validateError = () => {
    const err = [];
    let check = true;
    const a = addedItem.map((item, i) => {
      err.push({ name: "", email: "" });
      if (!item.name) {
        err[i]["name"] = "Name is required";
        check = false;
      }
      if (!item.email) {
        err[i]["email"] = "Email is required";
        check = false;
      }
      if (!item.location) {
        err[i]["location"] = "Location is required";
        check = false;
      }
    });
    setErrors(err);
    return check;
  };

  const sendBuyerList = () => {
    if (!validateError()) return;

    setLoading(true);
    ref?.current?.continuousStart();
    const payload = {
      auctionId: `${props?.listing?.auction_id}`,
      buyers: addedItem.map((item) => ({
        name: item?.name ? (item.name?.name ? item.name?.name : item?.name) : "",
        email: item?.email ? item.email : "",
        phone: item?.phone ? item.phone : "",
        location: item?.location ? item.location : "",
        category_id_push: item?.catgeory?.length > 0 ? item?.catgeory?.map((cn) => cn?.category_id).join(",") : "",
        geo_region_id_push: item?.region?.length > 0 ? item?.region?.map((cn) => cn?.value).join(",") : "",
        company: item?.company ? item?.company : "",
      })),
    };
    shareMyBuyerList(payload, (res) => {
      if (res && res.status == 200) {
        ref?.current?.complete();
        setLoading(false);
        setStep("2");
        setAddedItem([
          { name: "", email: "", phone: "", location: "", catgeory: [], company: "", region: "", type: "New" },
        ]);
      } else {
        setLoading(false);
        ref?.current?.complete();
        toast(<AlertError message={res?.data?.message ? res?.data?.message : "Something went wrong"} />);
      }
    });
  };

  useEffect(() => {
    if (props.show) {
      ref?.current?.continuousStart();
      getMyReferrals((res) => {
        if (res && res.status == 200) {
          ref?.current?.complete();
          setMyReferrals(res?.data?.data);
        }
      });
    }
  }, [props.show]);

  useEffect(() => {
    if (props.show) {
      setAddedItem([
        { name: "", email: "", phone: "", location: "", catgeory: [], company: "", region: "", type: "New" },
      ]);
      getCategories({}, (res) => {
        if (res && res.status === 200) {
          setCategoryList(res.data);
        }
      });
    } else {
      setErrors([]);
    }
  }, [props.show]);

  const customStyles = {
    indicatorSeparator: (styles) => ({ display: "none" }),
    option: (provided, state) => ({
      ...provided,
      "&:hover": {
        backgroundColor: "#376830",
        color: "#fff",
      },
      color: state.isSelected ? "#fff" : "black",
      backgroundColor: state.isSelected ? "#376830" : state.isFocused ? "#f5f5f5" : provided.backgroundColor,
    }),
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#e4e4e4" : "#e4e4e4",
      boxShadow: "0 !important",
      "&:hover": {
        borderColor: "#e4e4e4",
      },
      "&:focus": {
        borderColor: "#e4e4e4",
      },
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      "&:hover": {
        backgroundColor: "#f5f5f5!important",
        color: "#6119c0",
      },
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        border: "1px solid #E0E0E0",
        backgroundColor: "#f5f5f5",
        color: "black",
        fontSize: "0.75rem",
        "&:hover": {
          border: "1px solid #47ad1d",
        },
      };
    },
  };

  return (
    <>
      <LoadingBar color="#47ad1d" ref={ref} />
      <Modal
        show={props.show}
        onHide={() => props.onHide()}
        className={`modal fade ${step === "1" ? "salvex-modal2" : "salvex-modal modal-md hide-header"}`}
        id="aviationParts"
        dialogClassName={`modal-dialog  ${step === "1" ? "modal-xl-broker" : ""} modal-dialog-centered`}
        contentClassName={`modal-content ${step === "2" ? "ask-question-modal-height" : ""}`}
      >
        {step === "1" && (
          <Modal.Header className="modal-header">
            <div>
              <h5 class="modal-title">Share with Buyers</h5>
              <p className="d-block" style={{ marginTop: "10px" }}>
                <span style={{ fontWeight: "500" }}>{props?.listing?.auction_id}</span> - {props?.listing?.title}
              </p>
            </div>
            <button type="button" class="btn-close" onClick={() => props.onHide()}></button>
          </Modal.Header>
        )}
        <Modal.Body
          className="modal-body aviation-procurement"
          style={{ overflowX: "auto", marginTop: "0px", paddingTop: "0px" }}
        >
          {step === "1" && (
            <div className="mb-3 share-buyer-modal1" style={{ minHeight: "300px" }}>
              {addedItem &&
                addedItem.length > 0 &&
                addedItem.map((item, i) => (
                  <div className="d-flex flex-wrap align-items-center share-buyer-modal  aviation-add-modal1 mt-4">
                    <span className="mt-3 share-buyer-width ">
                      <label>Type of Buyer</label>
                      <div class=" sale-type-radio " style={{ marginLeft: "-10px" }}>
                        <div class="fcrg-item">
                          <div class="form-check radio">
                            <input
                              class="form-check-input"
                              type="radio"
                              name={`ABflexRadioDefault00${i}`}
                              id={`ABflexRadio00__112${i}`}
                              checked={addedItem[i]?.type == "New"}
                              onClick={(e) => {
                                const data = [...addedItem];
                                data[i].type = "New";
                                data[i].name = "";
                                data[i].email = "";
                                data[i].phone = "";
                                data[i].location = "";
                                data[i].location = "";
                                data[i].region = "";
                                data[i].catgeory = "";
                                setAddedItem(data);
                              }}
                            />
                            <label for={`ABflexRadio00__112${i}`}>New</label>
                          </div>
                        </div>
                        <div class="fcrg-item">
                          <div class="form-check radio">
                            <input
                              class="form-check-input"
                              type="radio"
                              name={`ABflexRadioDefault00${i}`}
                              id={`ABflexRadio00__211${i}`}
                              checked={addedItem[i]?.type == "Existing"}
                              onClick={(e) => {
                                const data = [...addedItem];
                                data[i].type = "Existing";
                                data[i].name = "";
                                setAddedItem(data);
                              }}
                            />
                            <label for={`ABflexRadio00__211${i}`}>Existing</label>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span className="mt-3 share-buyer-width ">
                      <label>
                        Name<sup style={{ color: "Red" }}>*</sup>
                      </label>{" "}
                      {addedItem[i]?.type == "New" ? (
                        <input
                          class="form-control"
                          type="text"
                          value={addedItem[i]?.name}
                          id={`buyerDetail${i}`}
                          placeholder={"Add Name"}
                          onChange={(e) => {
                            const data = [...addedItem];
                            data[i].name = e.target.value;
                            setAddedItem(data);
                          }}
                        />
                      ) : (
                        <Select
                          onChange={(e) => {
                            const data = [...addedItem];
                            data[i].name = e;
                            const filterBuyer = myReferrals?.filter((ru) => ru?.user_member_id == e?.value)?.[0];

                            if (filterBuyer?.buyer_geo_regions?.length > 0) {
                              const filterBuyerRegion = regionOptions?.filter((rr) =>
                                filterBuyer?.buyer_geo_regions?.split(",")?.includes(rr?.value),
                              );
                              data[i].region = filterBuyerRegion;
                            }
                            data[i].catgeory = filterBuyer?.categories;
                            data[i].phone = filterBuyer?.buyer_phone;
                            data[i].email = filterBuyer?.buyer_email;
                            setAddedItem(data);
                          }}
                          menuPosition="fixed"
                          menuShouldScrollIntoView
                          options={myReferrals.map((item) => ({
                            name: item?.buyer_name,
                            value: item?.user_member_id,
                          }))}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.value}
                          defaultOptions
                          styles={customStyles}
                          placeholder="Select Buyer"
                          value={addedItem[i]?.name}
                        />
                      )}
                      {errors && errors[i] && errors[i]?.name ? <p class="error">{errors[i]?.name}</p> : ""}
                    </span>{" "}
                    <span className="mt-3 share-buyer-width ">
                      <label>
                        Email<sup style={{ color: "Red" }}>*</sup>
                      </label>{" "}
                      <input
                        class="form-control"
                        type="text"
                        value={addedItem[i]?.email}
                        disabled={addedItem[i]?.type == "Existing" ? true : false}
                        id={`buyerDetail${i}`}
                        placeholder={"Add Email"}
                        onChange={(e) => {
                          const data = [...addedItem];
                          data[i].email = e.target.value;
                          setAddedItem(data);
                        }}
                      />
                      {errors && errors[i] && errors[i]?.email ? <p class="error">{errors[i]?.email}</p> : ""}
                    </span>
                    <span className="mt-3 share-buyer-width ">
                      <label>Phone</label>{" "}
                      <input
                        class="form-control"
                        type="number"
                        value={addedItem[i]?.phone}
                        disabled={addedItem[i]?.type == "Existing" ? true : false}
                        id={`buyerDetail${i}`}
                        placeholder={"Add Phone"}
                        onChange={(e) => {
                          const data = [...addedItem];
                          data[i].phone = e.target.value;
                          setAddedItem(data);
                        }}
                      />
                      {errors && errors[i] && errors[i]?.phone ? <p class="error">{errors[i]?.phone}</p> : ""}
                    </span>
                    <span className="mt-3 share-buyer-width ">
                      <label>Company</label>{" "}
                      <input
                        class="form-control"
                        type="text"
                        value={addedItem[i]?.company}
                        id={`buyerDetail${i}`}
                        placeholder={"Add Name"}
                        onChange={(e) => {
                          const data = [...addedItem];
                          data[i].company = e.target.value;
                          setAddedItem(data);
                        }}
                      />
                      {errors && errors[i] && errors[i]?.company ? <p class="error">{errors[i]?.company}</p> : ""}
                    </span>
                    <span className="mt-3 share-buyer-width ">
                      <label>
                        Location<sup style={{ color: "Red" }}>*</sup>
                      </label>{" "}
                      <input
                        class="form-control"
                        type="text"
                        value={addedItem[i]?.location}
                        id={`buyerDetail${i}`}
                        placeholder={"Add Location"}
                        onChange={(e) => {
                          const data = [...addedItem];
                          data[i].location = e.target.value;
                          setAddedItem(data);
                        }}
                      />
                      {errors && errors[i] && errors[i]?.location ? <p class="error">{errors[i]?.location}</p> : ""}
                    </span>{" "}
                    <span className="mt-3  share-buyer-width ">
                      <label>Region</label>{" "}
                      <Select
                        onChange={(e) => {
                          const data = [...addedItem];
                          data[i].region = e;
                          setAddedItem(data);
                        }}
                        menuPosition="fixed"
                        menuShouldScrollIntoView
                        isMulti
                        options={regionOptions}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.value}
                        defaultOptions
                        styles={customStyles}
                        placeholder="Select Region"
                        value={addedItem[i]?.region}
                      />
                    </span>
                    <span className="mt-3  share-buyer-width share-category" style={{ marginRight: "0px" }}>
                      <label>Category</label>{" "}
                      <Select
                        onChange={(e) => {
                          const data = [...addedItem];
                          data[i].catgeory = e;
                          setAddedItem(data);
                        }}
                        menuPosition="fixed"
                        menuShouldScrollIntoView
                        isMulti
                        options={categoryList.map((item) => {
                          return {
                            label: item.description,
                            options:
                              item.subCategories?.subCategories?.length > 0
                                ? item.subCategories?.subCategories
                                : item.subCategories,
                          };
                        })}
                        getOptionLabel={(option) => option.description}
                        getOptionValue={(option) => option.category_id}
                        defaultOptions
                        styles={customStyles}
                        placeholder="Select Category"
                        value={addedItem[i]?.catgeory}
                      />
                    </span>
                    <span className="delete-icon-width mt-3">
                      <div
                        class="td-delete-icon mt-3"
                        onClick={() => {
                          const data = [...addedItem];
                          const err = [...errors];
                          const remainingData = data.filter((item, j) => j != i);
                          const remainingError = err.filter((item, j) => j != i);
                          setAddedItem(remainingData);
                          setErrors(remainingError);
                        }}
                      >
                        {i !== 0 && <img src={trashIcon} alt="delete" />}
                      </div>
                    </span>
                  </div>
                ))}
            </div>
          )}
          {step === "2" && (
            <>
              <div class="sucessfull-askQuestion-box  sucessfull-submit-box help-box-success">
                <img src={crosshair} alt="crosshair" />
                <h4 style={{ fontSize: "1.25rem" }}>An email has been sent to buyers.</h4>
                <button
                  type="button"
                  class={`btn btn-default btn-sm`}
                  onClick={() => {
                    setStep("1");
                    props.onHide();
                  }}
                >
                  Close
                </button>
              </div>
            </>
          )}
        </Modal.Body>
        {step === "1" && (
          <Modal.Footer className="modal-footer footer-border pt-0 footer-procurement-btn addPart-padding-left">
            {" "}
            <a
              href="javascript:void(0)"
              class={`button-save button-save-aviation ${loading ? "disabled" : ""}`}
              onClick={() => {
                const data = [...addedItem];
                data.push({
                  name: "",
                  email: "",
                  phone: "",
                  location: "",
                  catgeory: [],
                  company: "",
                  region: "",
                  type: "New",
                });
                setAddedItem(data);
              }}
            >
              <svg
                style={{ height: "20px", marginBottom: "3px" }}
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.7341 5.61597V19.616"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.73415 12.616H19.7341"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Add New
            </a>
            <a
              href="javascript:void(0)"
              style={{ marginRight: "20px" }}
              class={`btn btn-default ${loading ? "disabled" : ""}`}
              onClick={() => sendBuyerList()}
            >
              Submit
            </a>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default ShareWithMyBuyers;
